<script>
    export default {
        name: 'BellIcon',
        props: {
            width: {
                type: [Number, String],
                required: false,
                default: 24,
            },
            height: {
                type: [Number, String],
                required: false,
                default: 24,
            },
        },
    };
</script>

<template>
    <svg :width="width" :height="height" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="fill-current">
        <path
            d="M4 15v-5a8 8 0 1116 0v5h2v3.5a2.5 2.5 0 01-2.5 2.5h-15A2.5 2.5 0 012 18.5V15h2zm2 0h12v-5a6 6 0 00-12 0v5zm14 2H4v1a1 1 0 001 1h14a1 1 0 001-1v-1zM8 10a4 4 0 014-4v2a2 2 0 00-2 2H8z"
            fill-rule="evenodd" />
    </svg>
</template>
